var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-toolbar",
        { attrs: { dense: "", outlined: "", flat: "" } },
        [
          _c("v-spacer"),
          _c(
            "v-btn-toggle",
            {
              attrs: { mandatory: "", dense: "" },
              model: {
                value: _vm.computedSettings.viewMode,
                callback: function ($$v) {
                  _vm.$set(_vm.computedSettings, "viewMode", $$v)
                },
                expression: "computedSettings.viewMode",
              },
            },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              { attrs: { text: "", value: "dashboard" } },
                              on
                            ),
                            [_c("v-icon", [_vm._v("mdi-view-dashboard")])],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v("Dashboard")])]
              ),
              _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              { attrs: { text: "", value: "tabular" } },
                              on
                            ),
                            [_c("v-icon", [_vm._v("mdi-view-list")])],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v("Tabular")])]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }